export enum SectionIds {
  Hero = "app-hero",
  ProductFeatures = "product-features",
  SystemSkeyTix = "system-skey-tix",
  SystemAdvantages = "system-advantages",
  ApiIntegration = "api-integration",
  SkeyPoap = "skey-poap",
  Footer = "app-footer"
}
